import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import i18next from 'i18next';
import responseErrorCondition from './responseErrorCondition';
import ErrorDataMessageConfig from '../entity/ErrorDataMessageConfig';
/**
 * @param {ErrorResponse} errorResponse
 *
 * @returns {Promise<?string>}
 */

export default /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(errorResponse) {
    var t, defaultMessage;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return i18next.loadNamespaces('error-message-resolver');

          case 2:
            t = i18next.getFixedT(null, 'error-message-resolver');
            defaultMessage = new ErrorDataMessageConfig().setConfig({
              invalid_request: t('invalid_request'),
              invalid_parameters: t('invalid_parameters'),
              forbidden: t('forbidden'),
              internal_server_error: t('internal_server_error')
            });
            _context.next = 6;
            return responseErrorCondition(errorResponse, defaultMessage);

          case 6:
            _context.t0 = _context.sent;

            if (_context.t0) {
              _context.next = 9;
              break;
            }

            _context.t0 = null;

          case 9:
            return _context.abrupt("return", _context.t0);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
})();